function dragScroll(scrollableElement: HTMLElement) {
  if (!scrollableElement) throw new Error('Scrollable element is required.')
  if (scrollableElement.dataset.dragScrollEnabled === 'true') return () => {}

  let isDragging = false
  let startX = 0
  let scrollLeft = 0

  const onMouseDown = (e: MouseEvent) => {
    // Prevent dragging if inside the <thead>
    const target = e.target as HTMLElement
    if (
      target.closest(
        'thead, button, a, input, textarea, select, option, [role="button"], .v-input, .v-field, .v-select, .v-text-field, .v-autocomplete, .v-btn',
      )
    ) {
      return // Do not start dragging if mouse is over <thead>
    }

    isDragging = true
    startX = e.pageX - scrollableElement.offsetLeft
    scrollLeft = scrollableElement.scrollLeft
    scrollableElement.style.cursor = 'grabbing'
    scrollableElement.style.userSelect = 'none' // Prevent text selection
  }

  const onMouseMove = (e: MouseEvent) => {
    if (!isDragging) return
    const x = e.pageX - scrollableElement.offsetLeft
    const walk = (x - startX) * 1.5 // Adjust scroll sensitivity
    scrollableElement.scrollLeft = scrollLeft - walk
  }

  const onMouseUpOrLeave = () => {
    isDragging = false
    scrollableElement.style.cursor = 'grab'
    scrollableElement.style.userSelect = '' // Restore default behavior
  }

  // Attach event listeners
  scrollableElement.addEventListener('mousedown', onMouseDown)
  scrollableElement.addEventListener('mousemove', onMouseMove)
  scrollableElement.addEventListener('mouseup', onMouseUpOrLeave)
  scrollableElement.addEventListener('mouseleave', onMouseUpOrLeave)

  // Initial cursor style
  scrollableElement.style.cursor = 'grab'
  scrollableElement.dataset.dragScrollEnabled = 'true'

  // Cleanup function
  return () => {
    scrollableElement.removeEventListener('mousedown', onMouseDown)
    scrollableElement.removeEventListener('mousemove', onMouseMove)
    scrollableElement.removeEventListener('mouseup', onMouseUpOrLeave)
    scrollableElement.removeEventListener('mouseleave', onMouseUpOrLeave)
    scrollableElement.style.cursor = ''
    scrollableElement.style.userSelect = ''
    delete scrollableElement.dataset.dragScrollEnabled
  }
}

export const enableTableDragScroll = (tableWrapperClassName: string) => {
  const tableWrappers = document.getElementsByClassName(tableWrapperClassName) // Get parent containers by class name

  if (!tableWrappers.length) {
    console.error('No table wrappers found with the class name:', tableWrapperClassName)
    return () => {}
  }

  const cleanupFns: Array<() => void> = []

  for (let i = 0; i < tableWrappers.length; i++) {
    const wrapper = tableWrappers[i] as HTMLElement
    // Locate the Vuetify table wrapper
    const scrollableElement = wrapper.querySelector('.v-table__wrapper') as HTMLElement

    if (!scrollableElement) {
      console.error('No scrollable element (v-table__wrapper) found inside the wrapper:', wrapper)
      continue
    }

    cleanupFns.push(dragScroll(scrollableElement))
  }

  return () => {
    cleanupFns.forEach(cleanup => cleanup())
  }
}
